import { useState, useEffect, useMemo } from 'react';
import { 
  DgtPdOrderOperationLog
} from '../models'

import {
  getBulkInspectionLogs
} from '../states/PicklistAction'

import { getDates } from '../utilities/Format'

export default function useBulkInpsectionLog(
  dateFrom: Date,
  dateTo: Date,
  searchByOrder: string
) : [ DgtPdOrderOperationLog[], (updatedLog: DgtPdOrderOperationLog) => void] {
  const [ operationLogs, setOperationLogs ] = useState<DgtPdOrderOperationLog[]>([]);

  const mutate = (updatedLog: DgtPdOrderOperationLog) => {
    setOperationLogs(operationLogs.map(log => log.id === updatedLog.id ? updatedLog : log));
  };

  useEffect(() => {
    const periodDates = getDates(dateFrom, dateTo)
    Promise.allSettled(periodDates.map(date => {
      return getBulkInspectionLogs(date)
    })).then(results => {
      const totalReturns = (results
        .filter(res => res.status === 'fulfilled') as PromiseFulfilledResult<DgtPdOrderOperationLog[]>[])
        .reduce((prev, cur) => [...prev, ...cur.value], [] as DgtPdOrderOperationLog[])
        .sort((a, b) => a.productionOrderId.localeCompare(b.productionOrderId))
        setOperationLogs(totalReturns)
    })
    .catch(err => console.error(err))
  }, [ dateFrom, dateTo ]);

  const filteredReturns = useMemo(() => operationLogs.filter(ex => ex.productionOrderId.includes(searchByOrder)), [ searchByOrder, operationLogs ])
  return [ filteredReturns, mutate ]
}